import React, {Component} from 'react';

import IntroNumbers from './IntroNumbers';
import TestNumbers from './TestNumbers';
import TrialNumbers from './TrialNumbers';
import TrialWords from './TrialWords';
import IntroWords from './IntroWords';
import TestWords from './TestWords';
import Pause from '../../components/Pause';
import strings from '../../strings';

const subStages = [
	IntroNumbers,
	TrialNumbers,
	Pause,
	TestNumbers,
	Pause,
	IntroWords,
	TrialWords,
	Pause,
	TestWords,
	Pause,
];

const testStages = [4, 9];
class WorkingMemoryWords extends Component {
	constructor(props) {
		super(props);

		this.state = {
			currentStage: 0,
			currentStep: 0,
		};
	}

	componentWillReceiveProps(newProps) {
		const newState = {};
		let flag = false;
		if (newProps.currentStep !== this.props.currentStep) {
			newState.currentStep = newProps.currentStep;
			flag = true;
		}
		if (newProps.currentStage !== this.props.currentStage) {
			newState.currentStage = newProps.currentStage;
			flag = true;
		}
		if (flag) {
			this.setState(newState);
		}
	}

	render() {
		const {currentStage, currentStep} = this.state;
		const {
			testKeyType = null,
			nextStep,
			setReady,
			startTimer,
			endTimer,
			ageGroup,
		} = this.props;

		const isAdultFollowup = testKeyType === 'adult-followup';
		const isGerman = strings.getLanguage() === 'de';

		const CurrentSubStage = subStages[currentStage];

		const isNumberStage = currentStage < 5;

		const testName = isNumberStage
			? isAdultFollowup
				? strings.wsn_testname_adult
				: strings.wsn_testname
			: isAdultFollowup
				? strings.wsw_testname_adult
				: strings.wsw_testname;

		const pauseSound = isGerman
			? !testStages.includes(currentStage)
				? 'trial'
				: 'test'
			: 'test';
		return (
			<div className="WorkingMemory">
				{!isAdultFollowup && (
					<h1 className="lit-page-title">{strings.ws_testname}</h1>
				)}
				{isAdultFollowup && isNumberStage && (
					<h1 className="lit-page-title">
						{strings.wsn_testname_adult}
					</h1>
				)}
				{isAdultFollowup && !isNumberStage && (
					<h1 className="lit-page-title">
						{strings.wsw_testname_adult}
					</h1>
				)}

				<CurrentSubStage
					currentStep={currentStep}
					nextStep={nextStep}
					setReady={setReady}
					startTimer={startTimer}
					endTimer={endTimer}
					testKeyType={testKeyType}
					ageGroup={ageGroup}
					testName={testName}
					pauseSound={pauseSound}
				/>
			</div>
		);
	}
}

export default WorkingMemoryWords;
